/* eslint-disable */
import MathUtil from '@/util/MathUtil';

class ItemUtil {
    /**
     * A price the merchant has actually entered. Blank is a legitimate state — an item sold takeaway only
     * has no dine-in price — and parseFloat("") is NaN, which Math.round happily carries all the way to the
     * screen as "kr NaN".
     */
    hasPrice(price){
        return price !== null && price !== undefined && price !== '' && isFinite(parseFloat(price));
    }

    /**
     * Whether every price that makes up the dine-in figure exists. False for a takeaway-only item (fine,
     * the caller simply shows nothing) and false for one that IS sold dine-in but is missing a price on
     * some variant - which is not fine, because ordering it would compute NaN on the terminal.
     */
    hasCompleteDineInPrice(item){
        if(!item.subselections || item.subselections.length === 0){
            return this.hasPrice(item.priceDineIn);
        }
        return item.subselections.every(subselection => this.hasPrice(subselection.priceDineIn));
    }

    getItemSubselectionPriceRange(item) {
        //console.log('itemId: ' + item.id);
        if(item.subselections.length == 0){
            return this.hasPrice(item.price) ? item.price : ''; //Show two decimals
        }

        var prices = [];
        for (var i = 0; i < item.subselections.length; i++) {
            var subselection = item.subselections[i];
            if(!this.hasPrice(subselection.price)){
                continue; //Not priced yet - skip rather than render NaN
            }
            prices.push(subselection.price); //Show two decimals
        }
        prices = this.unique(prices);
        prices.sort(function(a, b) {
            if(a == b) { return 0; }
            if(a > b) {
                return 1;
            }else {
                return -1;
            }
        });
        //log.info('prices: ' + JSON.stringify(prices));
        var text = "";
        for (var i = 0; i < prices.length; i++) {
            text = text + prices[i] + "/";
        }
        text = text.substring(0, text.length - 1); // remove / at the end
        return text;
    }

    getItemSubselectionPriceRangeTakeaway(item, vat) {
        //console.log('itemId: ' + item.id);
        if(item.subselections.length == 0){
            return this.hasPrice(item.price) ? this.getPriceWithVat(parseFloat(item.price), vat) : '';
        }

        var prices = [];
        for (var i = 0; i < item.subselections.length; i++) {
            var subselection = item.subselections[i];
            if(!this.hasPrice(subselection.price)){
                continue;
            }
            prices.push(this.getPriceWithVat(parseFloat(subselection.price), vat));
        }
        prices = this.unique(prices);
        prices.sort(function(a, b) {
            if(a == b) { return 0; }
            if(a > b) {
                return 1;
            }else {
                return -1;
            }
        });
        //log.info('prices: ' + JSON.stringify(prices));
        var text = "";
        for (var i = 0; i < prices.length; i++) {
            text = text + prices[i] + "/";
        }
        text = text.substring(0, text.length - 1); // remove / at the end
        return text;
    }

    getItemSubselectionPriceRangeDineIn(item, vat) {
        //console.log('itemId: ' + item.id);
        if(item.subselections.length == 0){
            return this.hasPrice(item.priceDineIn) ? this.getPriceDineIn(parseFloat(item.priceDineIn), vat) : '';
        }

        var prices = [];
        for (var i = 0; i < item.subselections.length; i++) {
            var subselection = item.subselections[i];
            if(!this.hasPrice(subselection.priceDineIn)){
                continue; //Takeaway-only item, or a variant nobody priced for dine-in
            }
            prices.push(this.getPriceDineIn(parseFloat(subselection.priceDineIn), vat));
        }
        prices = this.unique(prices);
        prices.sort(function(a, b) {
            if(a == b) { return 0; }
            if(a > b) {
                return 1;
            }else {
                return -1;
            }
        });
        //log.info('prices: ' + JSON.stringify(prices));
        var text = "";
        for (var i = 0; i < prices.length; i++) {
            text = text + prices[i] + "/";
        }
        text = text.substring(0, text.length - 1); // remove / at the end
        return text;
    }

    getPriceWithoutVat(vatRate, amountWithVat){
        var amountWithoutVat = amountWithVat/(100 + vatRate) * 100;
        //console.log("amountWithoutVat: " + amountWithoutVat);
        return MathUtil.roundTwoDecimals(amountWithoutVat); //With two decimals will the price with vat in Webshop be calculated right!
    }

    getPriceWithVat(priceWithoutVat, vat){
        let priceTakeaway = priceWithoutVat + (priceWithoutVat / 100 * vat.takeOut);
        return Math.round(priceTakeaway);
    }

    getPriceDineIn(priceWithoutVat, vat){
        let priceDineIn = priceWithoutVat + (priceWithoutVat / 100 * vat.dineIn);
        return Math.round(priceDineIn);
    }

    /**
     * Unique items in array.
     */
    unique(array) {
        var u = {}, a = [];
        for(var i = 0, l = array.length; i < l; ++i){
            if(!Object.prototype.hasOwnProperty.call(u, array[i])) {
                a.push(array[i]);
                u[array[i]] = 1;
            }
        }
        return a;
    }
}

export default new ItemUtil();

